import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgInfoCircleMid = function SvgInfoCircleMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2 12C2 6.47716 6.47716 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9C11.4477 9 11 8.55231 11 8 11 7.44798 11.4475 7 12 7 12.5522 7 13 7.44779 13 8 13 8.55251 12.552 9 12 9ZM12 10C11.5858 10 11.25 10.3358 11.25 10.75V16.25C11.25 16.6642 11.5858 17 12 17 12.4142 17 12.75 16.6642 12.75 16.25V10.75C12.75 10.3358 12.4142 10 12 10Z"
  })));
};

export { SvgInfoCircleMid as ReactComponent };
//# sourceMappingURL=info-circle-mid.svg.js.map
